<template>
  <div class="flex justify-around my-4 pr-16">
    <template v-for="(item, idx) in data" :key="idx">
      <div class="space-x-4 items-center">
        <div>
          <h3 class="text-sm font-medium uppercase leading-4">
            Rendimiento (Kg/ha)
          </h3>
          <h3 v-show="data.length > 1">
            <small>{{ item.name }}</small>
          </h3>
          <p class="font-bold text-2xl inline-flex items-center space-x-2">
            {{ numberWithPrecision(harvestedByCropField(item) / item.hectares, 2) }}
          </p>
        </div>
      </div>
    </template>
    <div class="space-x-4 items-center">
      <div>
        <p class="text-sm font-medium uppercase leading-4">Total (Kg)</p>
        <p class="font-bold text-2xl inline-flex items-center space-x-2">
          {{ numberWithPrecision(harvested_total) }}
        </p>
      </div>
    </div>
  </div>
  <div id="chart4">
    <apexchart
      type="line"
      height="350"
      width="100%"
      :options="options"
      :series="series"
    ></apexchart>
  </div>
</template>

<script>
import VueApexCharts from "vue3-apexcharts";

export default {
  name: "ORGProductionProductivityByProducerExpShowProducerChartMonthlyReport",
  components: {
    apexchart: VueApexCharts
  },
  props: {
    data: { required: true },
    months: {required: true, type: Array },
  },
  data() {
    return {
      options: {
        chart: {
          height: 350,
          type: "line",
          zoom: {
            enabled: false
          }
        },
        stroke: {
          curve: "straight"
        },
        grid: {
          row: {
            colors: ["#f3f3f3", "transparent"],
            opacity: 0.5
          }
        },
        xaxis: {
          categories: this.months
        },
        yaxis: {
          title: {
            text: "Kilogramos"
          },
          labels: {
            formatter: function (val) {
              return this.numberWithPrecision(val, 0);
            }.bind(this)
          }
        },
        colors: ["#65A30D"],
        legend: {
          position: "top",
          horizontalAlign: "right",
          floating: false,
          offsetY: -25,
          offsetX: -5
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return this.numberWithPrecision(val);
            }.bind(this)
          }
        },
      }
    };
  },
  computed: {
    series() {
      return this.data.map(item => {
        return {
          name: item.name,
          data: item.productivity.map(p => p.productivity || 0)
        };
      });
    },
    harvested_total() {
      return this.data
        .map(item => item.productivity.reduce((sum, p) => sum + Number(p.total_exported), 0))
        .reduce((sum, v) => sum + v, 0);
    }
  },
  methods: {
    harvestedByCropField(item) {
      return item.productivity.reduce((sum, p) => sum + Number(p.total_exported), 0);
    }
  }
};
</script>
